import { createSelector } from 'reselect';
import { selectCurrentInstance } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { isEmpty } from 'underscore';
// @ts-expect-error not typed
import makeSaveActions from 'ContentEditorUI/js/redux/actions/makeSaveActions';
// @ts-expect-error not typed
import bus from 'ContentEditorUI/coffee/lib/eventBus';
// @ts-expect-error not typed
import makeWaitForPendingInpageUpdates from 'ContentEditorUI/utils/makeWaitForPendingInpageUpdates';
// @ts-expect-error not typed
import { clearSaveAlerts } from 'ContentEditorUI/utils/errorUtils';
// @ts-expect-error not typed
import { validationFinished } from 'ContentEditorUI/redux/actions/appActions';
import { selectActiveHubDbRowId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { BASE_API_URL } from '../../constants';
import { hasEditorPermission } from 'case-study-lib/utils/auth';
export const selectSaveData = createSelector([selectCurrentInstance], currentInstance => currentInstance);
export const selectHasEmptyTitle = createSelector([selectCurrentInstance], currentInstance => {
  const instanceName = currentInstance && currentInstance.values.hs_name;
  return instanceName.trim() === '';
});
export const selectCanSave = createSelector([selectHasEmptyTitle], hasEmptyTitle => {
  return hasEditorPermission() && !hasEmptyTitle;
});

// actions
function formatApiUrl(state) {
  const currentInstance = selectActiveHubDbRowId(state);
  return `${BASE_API_URL}/${currentInstance}/draft`;
}
const actions = makeSaveActions({
  apiUrl: formatApiUrl,
  isStructuredContent: true,
  serialize: selectSaveData,
  wait: makeWaitForPendingInpageUpdates(bus)
});
export const save = opts => {
  clearSaveAlerts();
  return actions.save(opts);
};
export const autoSave = actions.autoSave;
export const autoSaveDebounced = actions.autoSaveDebounced;
export const validate = () => dispatch => {
  const errors = {};
  const valid = isEmpty(errors);
  return dispatch(validationFinished({
    valid,
    errors
  }));
};